import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

import type { UpdateApprovalTags } from '../../types/tags'
const { TAGS_API_URL } = CONSTANT

const updateMultiStepTagsById = async (
	updateTags: UpdateApprovalTags
): Promise<Response> => {
	const response = await fetchWithAuthorizationHeader(`${TAGS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'UPDATE_APPROVER_STATUS'
		},
		body: JSON.stringify(updateTags)
	})

	return response
}

export default updateMultiStepTagsById
